import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { Cookies, resetCookieConsentValue } from 'react-cookie-consent';
import './cookie.scss';

export const COOKIE_NAME = 'epaperqualitaeten';

const useCookieNotice = () => {
  const [seen, setSeen] = useState(true);

  useEffect(() => {
    // https://www.gatsbyjs.org/docs/debugging-html-builds/#how-to-check-if-window-is-defined
    if (typeof window === 'undefined') {
      return null;
    }

    setSeen(Cookies.get(COOKIE_NAME) !== undefined);
  }, []);

  const setAcceptAllCookies = () => {
    if (typeof window !== 'undefined') {
      Cookies.set(COOKIE_NAME, 'true', { expires: 365 });
      window._paq.push(['setConsentGiven']);
      window._paq.push(['trackPageView']);
      window._paq.push(['enableLinkTracking']);
    }
    setSeen(true);
  };

  const setAcceptFunctionalCookies = () => {
    if (typeof window !== 'undefined') {
      Cookies.set(COOKIE_NAME, 'true', { expires: 365 });
    }
    setSeen(true);
  };

  const resetCookieSettings = () => {
    resetCookieConsentValue();
    setSeen(false);
  };

  return [seen, setAcceptAllCookies, setAcceptFunctionalCookies, resetCookieSettings];
};

const Cookie = ({ resetCookies = false }) => {
  const [seen, setAcceptAllCookies, setAcceptFunctionalCookies, resetCookieSettings] = useCookieNotice();

  useEffect(() => {
    if (resetCookies) {
      resetCookieSettings();
    }
  }, [resetCookies, resetCookieSettings]);

  if (seen) {
    return null;
  }

  return (
    <div className={`Cookie ${seen ? 'Cookie--seen' : ''}`}>
      <h1 className="h4">Wir verwenden Cookies</h1>
      <p className="mb-4">
        Diese Webseite benutzt Cookies, um seinen Lesern das beste Webseiten-Erlebnis zu ermöglichen. Außerdem werden
        teilweise auch Cookies von Diensten Dritter gesetzt. Weiterführende Informationen erhalten Sie in der{' '}
        <Link to="/data-privacy">Datenschutzerklärung</Link>.
      </p>
      <button className="btn btn-primary mr-2" onClick={setAcceptAllCookies}>
        Alle Cookies akzeptieren
      </button>
      <button className="btn btn-secondary mr-2" onClick={setAcceptFunctionalCookies}>
        Nur funktionale Cookies
      </button>
    </div>
  );
};

export default Cookie;
